import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {ResponsiveSheet} from '@chekinapp/ui';
import {ContentText, StyledLink} from './styled';
import {useReservation} from 'context/reservation';
import {useFetchPrivacyPolicySettings} from 'hooks';

type TaxesInformationModalProps = {
  isOpen: boolean;
  close: () => void;
};
const TaxesInformationModal = memo(({isOpen, close}: TaxesInformationModalProps) => {
  const {t} = useTranslation();
  const {housingId} = useReservation();
  const {hasCustomPrivacyPolicy, documentDownload, isLoading} =
    useFetchPrivacyPolicySettings({housingId});

  return (
    <ResponsiveSheet
      open={isOpen}
      onClose={close}
      title={t('tourist_taxes')}
      className="tax-info-modal"
      closeOnOverlayClick
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
    >
      <ContentText className="tax-info-modal__content">
        <p>{t('please_be_advised_that_in_this_territory')}</p>
        <p>{t('thank_you_for_your_understanding')}</p>

        {hasCustomPrivacyPolicy ? (
          <StyledLink
            download
            label={t('view_privacy_policy')}
            href={documentDownload}
            disabled={isLoading || !documentDownload}
          />
        ) : (
          <StyledLink
            label={t('view_privacy_policy')}
            href={t('guest_privacy_policy_link')}
          />
        )}
      </ContentText>
    </ResponsiveSheet>
  );
});

export {TaxesInformationModal};
